import { render, staticRenderFns } from "./factures.html?vue&type=template&id=7a478983&scoped=true&external"
import script from "./factures.js?vue&type=script&lang=js&external"
export * from "./factures.js?vue&type=script&lang=js&external"
import style0 from "./factures.scss?vue&type=style&index=0&id=7a478983&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a478983",
  null
  
)

export default component.exports